export default __webpack_public_path__ + "static/media/unit-1-part-2.8252c59a.pdf";